import React from 'react'
import { AddressDivisionsContextType } from './AddressDivisions.interface'

export const AddressDivisionsContext = React.createContext<AddressDivisionsContextType>({})
